// Small theme helper — reads/writes localStorage["syncbook_theme"] and toggles
// the `dark` class on <html>. Called at boot (index.js) and by the Profile
// toggle. No React dependency so it can run before hydration.

const KEY = "syncbook_theme";

export function getTheme() {
  try {
    const t = localStorage.getItem(KEY);
    if (t === "dark" || t === "light") return t;
  } catch {}
  return "light";
}

export function setTheme(t) {
  const next = t === "dark" ? "dark" : "light";
  try { localStorage.setItem(KEY, next); } catch {}
  applyTheme(next);
  return next;
}

export function applyTheme(t) {
  const html = document.documentElement;
  if (!html) return;
  if (t === "dark") html.classList.add("dark");
  else html.classList.remove("dark");
}

/** Bootstrap on module import — runs once when index.js loads it. */
applyTheme(getTheme());
